/**
 * /devhub/report-templates — Report templates (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubReportTemplatesPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubReportTemplatesPanel } from '../features/control-plane/DevHubReportTemplatesPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/report-templates')({ component: ReportTemplatesPage });

function ReportTemplatesPage() {
  return (
    <DevHubPanelPage
      title="Report templates"
      subtitle="Reusable report layouts and data-merge templates."
      status={{ label: 'live', live: true }}
    >
      <DevHubReportTemplatesPanel />
    </DevHubPanelPage>
  );
}
